const COLORS = {
  // severity
  critical: '#dc2626',
  high:     '#ea580c',
  medium:   '#d97706',
  low:      '#16a34a',
  // job status
  pending:    '#6366f1',
  processing: '#0891b2',
  sent:       '#16a34a',
  failed:     '#dc2626',
  // delivery
  success: '#16a34a',
};

export default function StatusBadge({ value }) {
  const color = COLORS[value] || '#6b7280';
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 10px',
      borderRadius: 12,
      fontSize: 12,
      fontWeight: 600,
      color: '#fff',
      background: color,
      textTransform: 'capitalize',
    }}>
      {value}
    </span>
  );
}
